module.exports = {
    defaultLanguage: 'es',
    profileColor: {saturation: 78, brightness: 100},
    scssVariables: './src/styles/adidas2024',
    favicon: 'adidasfavicon.ico',
    defaultPassword: 'default'
}